export default "__VITE_ASSET__CJg$6tld__"